// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_c05df67"};